import productData from "../data/productData";

export const imgHeight = (width) => {
    if (window.innerWidth >= 992) {
        return { height: "350px" }; // lg
    } else if (width >= 768) {
        return { height: "400px" }; //md
    }
    else if (width >= 576) {
        return { height: "300px" }; // sm
    } else {
        return { height: "200px" }; //  xs
    }
};

export const findKeysByName = (name) => {
    for (let [categoryKey, category] of Object.entries(productData)) {
        for (let [typeKey, typeObj] of Object.entries(category.types)) {
            if (typeObj.name === name) {
                return { categoryKey, typeKey };
            }
        }
    }
    return null;
};
